import React, { useEffect, useState } from "react"
import {
  nePasManquerContainer,
  nePasManquerTitle,
  nePasManquerResume,
  editButtonTitle,
} from "./ne-pas-manquer.module.scss"
import PropTypes from "prop-types"
import ContentTransformer from "../../Transformers/content-transformer"
import NePasManquerItem from "./NePasManquerItem/ne-pas-manquer-item"
import { useNePasManquer } from "./ne-pas-manquer-query"
import { getPublishedData } from "../../get-published-data"
import EditButton from "../../EditButton/edit-button"

//-----------------------Parent component---------------------------//

const ListNePasManquer = () => {
  const data = useNePasManquer()
  const [finalData, setFinalData] = useState([])

  useEffect(() => {
    setFinalData(getPublishedData(data.allNodePage.edges))
  }, [data])

  if (finalData.length === 0) {
    return null
  }
  return (
    <>
      <h2 className={nePasManquerTitle}>
        <EditButton
          addedClass={editButtonTitle}
          link={
            "/taxonomy/term/" +
            data.taxonomyTermZoneDefinie.drupal_internal__tid +
            "/edit"
          }
        />
        {data.taxonomyTermZoneDefinie?.field_label || "À ne pas manquer"}
      </h2>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={nePasManquerResume}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <div className={nePasManquerContainer} role={"list"}>
        <RenderNePasManquer nePasManquerData={finalData} />
      </div>
    </>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const RenderNePasManquer = ({ nePasManquerData }) => {
  return nePasManquerData.map(({ node }) => {
    return <NePasManquerItem key={node.drupal_id} nePasManquer={node} />
  })
}

//-----------------------Child component---------------------------//

//-----------------------Prop-Types---------------------------//

RenderNePasManquer.propTypes = {
  nePasManquerData: PropTypes.object.isRequired,
}
//-----------------------Prop-Types---------------------------//

export default ListNePasManquer
